import { render, staticRenderFns } from "./titlebox.html?vue&type=template&id=27af56ec&scoped=true&"
import script from "./titlebox.js?vue&type=script&lang=js&"
export * from "./titlebox.js?vue&type=script&lang=js&"
import style0 from "./titlebox.scss?vue&type=style&index=0&id=27af56ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af56ec",
  null
  
)

export default component.exports